import { FC } from "react";
import { BreadcrumbLink } from "./link";
import { useBucketContext } from "context/bucket";

type BreadcrumbProps = { breadcrumb: string };

export const BreadCrumb: FC<BreadcrumbProps> = (props) => {
  const { fetchHomePageData } = useBucketContext();
  const { breadcrumb } = props;
  const path = breadcrumb.split("/").filter((o) => o.length);

  const pathFactory = (array: string[], index: number) => {
    const temp = [...array];
    let count = array.length - (index + 1);
    while (count > 0) {
      temp.pop();
      count -= 1;
    }
    const path = temp.join("/");
    return path ? `${path}/` : "";
  };

  const handleOnClick = (array: string[], index: number) => {
    const path = pathFactory(array, index);
    fetchHomePageData(path ? path : undefined);
  };

  return (
    <div className="d-flex align-items-center g-2">
      {path.map((o, i, a) => {
        const isLastElement = i === path.length - 1;
        return (
          <div key={i} className="d-flex align-items-center g-2">
            <BreadcrumbLink fetchAction={() => handleOnClick(a, i)}>
              {i === 0 ? (
                <i className="bi bi-house-door-fill fs-2 text-light" />
              ) : (
                <span className="fs-5">{o}</span>
              )}
            </BreadcrumbLink>
            {isLastElement ? null : (
              <i className="bi bi-chevron-right text-light fs-6"></i>
            )}
          </div>
        );
      })}
    </div>
  );
};
